import { CouponCodeFormData } from '../../../../entities/@forms/CouponCodeForm/CouponCodeForm';
import {
    FormErrors,
    FormValidation,
    validateForm,
    validateRequiredString,
} from '../../../../entities/@forms/FormValidation/FormValidationService';

export type CouponFormErrors = FormErrors<CouponCodeFormData>;

export const validateCouponCodeFormData = (formData: CouponCodeFormData): FormValidation<CouponFormErrors> => {
    const errors: CouponFormErrors = {
        discountCode: validateRequiredString('couponCode', formData.discountCode),
    };

    return validateForm<CouponFormErrors>(errors);
};
